import { render, staticRenderFns } from "./ClearIcon.vue?vue&type=template&id=72949a05&scoped=true&"
var script = {}
import style0 from "./ClearIcon.vue?vue&type=style&index=0&id=72949a05&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../college-and-career-public/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72949a05",
  null
  
)

export default component.exports